<template>
    <div class="address-book">
        <el-dialog title="选择参会者" :visible.sync="dialogFormVisible" width="90%"
                   :close-on-click-modal="false" :before-close="handleClose">
            <el-row type="flex" justify="space-around">
                <el-col :span="12" class="left-panel">
                    <div class="panel-header">
                        <el-button type="default" plain size="small" class="float-right" @click="clearAddressBook">
                            <i class="fa fa-times-circle"></i> 清空
                        </el-button>
                        选中的参会者
                    </div>
                    <div class="panel-body">
                        <div v-for="item in address_book" class="address-item" :key="item.email" @dblclick="putEmailBack(item)">
                            {{item.name}}&lt;{{item.email}}&gt;
                            <div class="icon-button" @click="removeOneEmail(item)">
                                <i class="fa fa-times-circle"></i></div>
                        </div>
                    </div>
                    <div class="panel-footer">
                        <el-input type="textarea" v-model="import_text" style="height: 66px;"
                                  placeholder="输入email,可以批量，用','分割. 格式为 姓名 email,"></el-input>
                    </div>
                </el-col>
                <el-col :span="12" class="right-panel">
                    <div class="panel-header">
                        <el-button type="default" plain size="small" class="float-right" @click="addToAddress">
                            <i class="fa fa-arrow-circle-left"></i> 添加
                        </el-button>
                        <el-input size="mini" type="text" placeholder="搜索备用参会者" v-model="filter"
                                  clearable @clear="getYellowBook()"
                                  style="width: calc(100% - 80px)" @keyup.native="debounced()"></el-input>
                    </div>
                    <div class="panel-body">
                        <el-tabs tab-position="bottom" type="border-card"
                                 style="height: 312px;" @tab-click="handleTabClick">
                            <el-tab-pane v-for="tab in reference_tabs"
                                         :value="tab_index" :key="tab"
                                         :label="tab" style="height: 100%">
                                <div v-if="tab === '联系人'" style="height: 100%;overflow: auto;">
                                    <div v-for="item in contacts_filter" class="reference-item" :key="item.email"
                                         @dblclick="addOneEmail(item)" style="border-bottom: 1px solid #eee;">
                                        <div class=""
                                             style="font-size:13px;padding: 2px 0;margin-bottom: 2px;">
                                            <div class="d-flex justify-content-start align-items-center"
                                                 style="min-width: 5em;margin-right: 5px;color: #607d8b;overflow: hidden;text-overflow: ellipsis"
                                                 :title="item.name + (item.department || '' )">
                                                <b>{{item.name}}</b><span v-if="item.department"> ({{item.department}})</span>
                                            </div>
                                            <div style="line-height: normal; font-size: 13px;">
                                                {{item.email}}
                                            </div>
                                        </div>
                                        <div class="icon-button">
                                            <el-checkbox v-model="item.select"></el-checkbox>
                                        </div>
                                    </div>
                                </div>
                                <!-- 通讯组  -->
                                <div v-if="tab === '通讯组'" style="height: 100%;overflow: auto;">
                                    <div v-for="groupItem in group_filter" class="reference-item-head text-info"
                                         :key="groupItem.id"
                                         @dblclick="addGroupEmail(groupItem)">

                                        <div class="title-wrap">
                                            <div class="title-icon" @click.prevent="expendGroup(groupItem)">
                                                <i class="el-icon-arrow-right"
                                                   :class="groupItem.collapsed?'rotate-90':''"></i>
                                            </div>
                                            <div class="title">
                                                {{groupItem.name}}
                                                <div class="icon-button">
                                                    <el-checkbox v-model="groupItem.select"></el-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                        <el-collapse-transition>
                                            <div class="group-emails" v-if="groupItem.collapsed">
                                                <div v-for="item in groupItem.email_array" class="reference-item"
                                                     :key="item.email+item.name"
                                                     @dblclick="addOneEmail(item)"
                                                     style="border-bottom: 1px solid #eee;">
                                                    <div class=""
                                                         style="line-height:normal;font-size:13px;padding: 2px 0;margin-bottom: 2px;">
                                                        <div style="min-width: 8em;margin-right: 5px;color: #607d8b;margin-bottom: 5px;overflow: hidden;text-overflow: ellipsis"
                                                            :title="item.name + (item.department || '' )">
                                                            <!-- {{item.user_id | noEmail}}<br/> -->
                                                            <b>{{item.name}}</b><span v-if="item.department"> ({{item.department}})</span>
                                                        </div>
                                                        <div style="line-height: normal; font-size: 13px;margin-left: 1px;">
                                                            {{item.email}}
                                                        </div>
                                                    </div>
                                                    <div class="icon-button">
                                                        <el-checkbox v-model="item.select"></el-checkbox>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-collapse-transition>
                                    </div>
                                </div>
                                <!-- 黄页 -->
                                <div v-if="tab === '黄页'" style="height: 100%;overflow: auto;"
                                     v-infinite-scroll="loadYellowMore">
                                    <div v-for="item in yellow_book" class="reference-item" :key="item.id"
                                         @dblclick="addOneEmail(item)" style="border-bottom: 1px solid #eee;">
                                        <div class="d-flex"
                                             style="line-height:normal;font-size:13px;padding: 2px 0;margin-bottom: 2px">
                                            <div style="min-width: 8em;margin-right: 5px;color: #607d8b;overflow: hidden;text-overflow: ellipsis"
                                                 :title="item.name + (item.department || '' )">
                                                <b>{{item.name}}</b><span v-if="item.department"> ({{item.department}})</span>
                                            </div>
                                            <div style="line-height: normal; font-size: 13px;margin-left: 10px;">
                                                {{item.email}}
                                            </div>
                                        </div>
                                        <div class="icon-button">
                                            <el-checkbox v-model="item.select"></el-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button class="pull-left" type="primary" plain @click="importEmails">添加输入人员</el-button>
                <el-button class="pull-left" type="warning" plain @click="saveEmails">存入通讯录</el-button>
                <el-button @click.native="$emit('cancel')">取 消</el-button>
                <el-button type="primary" @click.native="editSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ElCollapseTransition from "element-ui/lib/transitions/collapse-transition";
    import addressBookPickerMixin from "../common/mixins/address-book-pick-mixin";

    export default {
        name: "group-edit",
        components: {ElCollapseTransition},
        mixins:[addressBookPickerMixin],
    }
</script>

<style lang="scss">

    .address-book {
        .group-name-row {
            height: 32px;
            margin: 5px 0;

            .label {
                width: 120px;
                line-height: 32px;
                text-align: center;
            }
        }

        .line {
            height: 0;
            border-bottom: 2px solid #ecf5ff;
            margin-bottom: 5px;
        }

        .left-panel {
            padding-right: 5px;
            margin-right: 5px;
            border-right: 1px solid #eee;

            .panel-body {
                height: 246px;
            }
        }

        .panel-header {
            height: 40px;
            background-color: #EEE;
            line-height: 32px;
            padding: 4px 10px;

        }

        .panel-body {
            overflow: auto;
        }

        .right-panel {
            background-color: transparent;

            .panel-body {
                height: calc(100% - 40px);
                background-color: #F9F8F9;

                .el-tabs__content {
                    height: calc(100% - 39px);
                    padding: 0 15px;
                }

                .el-tabs--bottom .el-tabs__header.is-bottom {
                    margin-top: 0 !important;
                }
            }
        }

        .el-dialog__body {
            padding: 5px 20px;
        }

        .address-item {
            line-height: 28px;
            color: #333;
            padding: 2px 25px 2px 10px;
            position: relative;
            transition: all 0.2s ease-in;
            border-radius: 0;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 13px;
            border-bottom: 1px solid #eee;

            .icon-button {
                position: absolute;
                right: 7px;
                top: 1px;
                padding: 0 2px;
                font-size: 15px;
                cursor: pointer;
                transition: all 0.2s ease-in;
                opacity: 0.1;

                &:hover {
                    color: #0288d1;
                    transform: scale(1.5);
                }
            }

            &:hover {
                background-color: #e0f7fa;

                .icon-button {
                    opacity: 1;
                }
            }
        }

        .reference-item-head {
            padding: 5px 0;
            position: relative;

            .title-wrap {
                border-bottom: 2px solid #E0E0E0;

                .title-icon {
                    float: left;
                    font-weight: bold;
                    display: block;
                    color: #607d8b;
                    line-height: 28px;
                    height: 28px;
                    padding: 2px;
                    width: 18px;
                    cursor: pointer;
                    transition: all 0.2s ease-in;

                    &:hover {
                        background-color: #e0f7fa;
                    }

                    i {
                        transition: all 0.2s ease-in;
                    }

                    .rotate-90 {
                        transform: rotate(90deg);
                    }
                }


                .title {
                    line-height: 28px;
                    color: #607d8b !important;

                    .icon-button {
                        top: 1px !important;
                    }

                    &:hover {
                        background-color: #e0f7fa;

                        .icon-button {
                            opacity: 1;
                        }
                    }
                }
            }

            .group-emails {
                padding: 10px 0 10px 15px;
            }
        }

        .reference-item, .reference-item-head .title {
            line-height: 28px;
            color: #333;
            padding: 2px 25px 2px 10px;
            position: relative;
            transition: all 0.2s ease-in;
            border-radius: 0;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .icon-button {
                position: absolute;
                right: 7px;
                top: 0;
                padding: 0 2px;
                font-size: 15px;
                cursor: pointer;
                transition: all 0.2s ease-in;
                opacity: 1;

                &:hover {
                    color: #0288d1;
                    transform: scale(1.5);
                }
            }

            &:hover {
                background-color: #e0f7fa;

                .icon-button {
                    opacity: 1;
                }
            }
        }
    }
</style>

